import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import VirtualizedList from './VirtualizedList.js';
import VirtualizedItem from './VirtualizedItem.js';
import '@babel/runtime/helpers/esm/defineProperty';
import 'react-spring/web.cjs';
import 'react-window';
import 'react-window-infinite-loader';
import 'react-virtualized-auto-sizer';
import '../animation/animationConfig.js';
import '../AnimationState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import 'constate';

var SortableList = sortableContainer(VirtualizedList);

function VirtualizedSortableList(_ref) {
  var items = _ref.items,
      otherProps = _objectWithoutProperties(_ref, ["items"]);

  return /*#__PURE__*/React.createElement(SortableList, _extends({}, otherProps, {
    items: items,
    useDragHandle: true
  }), sortableElement(VirtualizedItem));
}

export default VirtualizedSortableList;
//# sourceMappingURL=VirtualizedSortableList.js.map
